export const EVENT_KEY_CODES = {
	a: 65,
};

export const CAPTCHA_FF = 'CAPTCHA_ENABLED';
export const NEW_LOGIN_FLOW_FF = 'NEW_LOGIN_FLOW';

export const ASSIGN_VIEWER_ROLE_ERROR_MESSAGE =
	'Users with Viewer license are not permitted to get any role assignments';
export const OWNER_ROLE = 'owner';

export const EMPTY_ARR = [];

export const EMPTY_OBJ = {};

export const EMPTY_MAP = new Map();
